import React, { useState } from 'react';

const ButtonToggle = ({  initialState, onToggle, enabledColor = 'tw-bg-[#488328]', disabledColor = 'tw-bg-[#C9CCCF]', disabled=false }) => {
    const [enabled, setEnabled] = useState(initialState ?? false);

    const toggle = () => {
        setEnabled(!enabled);
        if (onToggle) {
            onToggle(!enabled);
        }
    };

    return (
        <button disabled={disabled} onClick={toggle} className={`tw-w-12 tw-h-6 tw-flex tw-items-center tw-rounded-full tw-p-1 tw-duration-300 tw-ease-in-out ${enabled ? enabledColor : disabledColor}`}> 
            <div className={`tw-bg-white tw-w-4 tw-h-4 tw-rounded-full tw-shadow-md tw-transform tw-duration-300 tw-ease-in-out ${enabled ? 'tw-translate-x-6' : ''}`}/>
        </button>
    );
};

export default ButtonToggle;

